import React, {  Component } from 'react';
import { browserHistory, Link } from 'react-router';
import { connect } from 'react-redux';
import _ from 'lodash';

/*Actions*/
import {
	getProductSpecs,
	saveProductSpecs,
	printSpecsPDF,
} from '../../../redux/actions';

/*Dialogs*/
import AvailabilityDetailsOverlayDialog from '../../dialogs/availabilityDetailsOverlayDialog';
import EstRetailPriceTooltipOverlayDialog from '../../dialogs/estRetailPriceTooltipOverlayDialog';

import EmailSpecOverlayDialog from '../../dialogs/emailSpecOverlayDialog';
import EmailSpecOverlayDialogSuccess from '../../dialogs/emailSpecOverlayDialogSuccess';

import $ from 'jquery';

import { routes } from '../../../redux/api/routes';
let { productGEUrl, geUrlImageRootImages, geUrlImageMigratedAssets } = routes;

/*Social share */
import {
	ShareButtons,
	generateShareIcon
} from 'react-share';
const {
	FacebookShareButton,
	GooglePlusShareButton,
	TwitterShareButton,
	PinterestShareButton
} = ShareButtons;
const FacebookIcon = generateShareIcon('facebook');
const TwitterIcon = generateShareIcon('twitter');
const GooglePlusIcon = generateShareIcon('google');
const PinterestIcon = generateShareIcon('pinterest');


class ProductSpecPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showAvailabilityDetailsOverlayDialog: false,
			showEstRetailPriceTooltipOverlayDialog: false,

			showEmailSpecOverlayDialog: false,
			specURL: '',
			element: null,

			isLargeImageSetOnLoad: false,

			collapseExpandAll: true,
			isPrelogin: true,
			basePath: '',
			isToolTipSet: false,

			currentSpecImage: 0,
			lastNum: 0,
			imgwidthvary: 81,
			movedOver: false,
			wasBackwards: false,
			startOver: false,
			moveOver: undefined,
			productImagesArray: null,

			socialIconSize: 24,
			mainImageSrc: '',

            tooltipOpen: false,
            tooltipPopUp: false,
            setMainImageFlg: false,
			isPairingModelsMsrpSet: false,
			accessoriesItem:'',
        }
		this.setToolTip = this.setToolTip.bind(this);
		this.setMainImage = this.setMainImage.bind(this);
		this.setPairingModelToolTipSet = this.setPairingModelToolTipSet.bind(this);
		this.updateStoreWithUpdatedSpecsData = this.updateStoreWithUpdatedSpecsData.bind(this);
    }

	collapseExpandAll(status, event) {
		event.preventDefault();
		if(status) {
			$('.acc_trigger').addClass("active");
			$('.acc_container').slideDown();
		} else {
			$('.acc_trigger').removeClass("active");
			$('.acc_container').slideUp();
		}
	}

	toggle(tab, event) {
		event && event.preventDefault();
		//Activate current tab heading after removig active from existing active tab
		$('.tabs li.active').removeClass('active');
		$('.tabs li#tab'+tab+'_top').addClass('active');

		//Show tab content based on current tab
		$('.tab_container .tab_content').hide();
		$('.tab_container #tab'+tab).fadeIn();
	}

	handleClickEmailSpec(event) {
        event.preventDefault();
		let specURL = window.location.pathname;
		if (specURL.indexOf('/prelogin/') === -1) {
			specURL = window.location.pathname.replace('/product-specs/', '/prelogin/product-specs/')
		}
        this.setState({
            specURL,
            showEmailSpecOverlayDialog: true
        });
    }

	getLinkOfDocumentByName(data, documentName) {
		let docLink = _.find(data,["type", documentName]);
		return docLink ? docLink.documentPath : "";
	}

	// event for close dialog
	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	checkArrayContainsWord(array, word) {
		var contains = false;
        array && array.values && array.values.map((item, index) => {
            if(item.value.indexOf(word) !== -1) {
				contains = true;
			}
            return null;
        })
		return contains;
	}

	prepareList(values, indx) {
		var list = [];
		if(values && values.length === 1) {
			list.push(<span key={indx}>{values[0]}</span>);
		} else {
			values && values.map((item, index) => {
				list.push(<span key={indx+index}>{item}<br/></span>);
				return "";
			});
		}
		return list;
	}

    prepareListForWeights_Dimensions(value, indx){
        var list = [];
		if(value && value.length === 1) {
			list.push(<span key={indx}>{parseFloat(value[0]).toFixed(2)}</span>);
		} else {
			value && value.map((item, index) => {
				list.push(<span key={indx+index}>{item}<br/></span>);
				return "";
			});
		}
		return list;
    }

	setToolTip() {
		this.setState({isToolTipSet: true});
		$('.newTooltip').each(function () {
				var distance = 10;
				var time = 250;
				var hideDelay = 100;

				var hideDelayTimer = null;

				var beingShown = false;
				var shown = false;
				var trigger = $('.trigger', this);
				var info = $('.popup', this).css('opacity', 0);

				$([trigger.get(0), info.get(0)]).mouseover(function () {
					if (hideDelayTimer) {
						clearTimeout(hideDelayTimer);
					}
					if (beingShown || shown) {
						// don't trigger the animation again
						return;
					} else {
						// reset position of info box
						beingShown = true;

						info.css({
							top: -171,
							left: -87,
							display: 'block'
						}).animate({
							top: '=' + distance + 'px',
							opacity: 1
						}, time, 'swing', function() {
							beingShown = false;
							shown = true;
						});
					}

					return false;
				}).mouseout(function () {
					if (hideDelayTimer) {
						clearTimeout(hideDelayTimer);
					}
					hideDelayTimer = setTimeout(function () {
						hideDelayTimer = null;
						info.animate({
							top: '-=' + distance + 'px',
							opacity: 0
						}, time, 'swing', function () {
							shown = false;
							info.css('display', 'none');
						});

					}, hideDelay);

					return false;
				});
			});
	}

	newSetMainImage(num, allImages, event) {
		event && event.preventDefault();
		this.setState({
			setMainImageFlg:true
		}, () => {
			//Custom declarations
			var productImagesArray = this.state.productImagesArray;
			if(!productImagesArray) {
				productImagesArray = [];
				allImages.map((item) => {
					productImagesArray.push([
						item.imagePath,
						item.imagePath,
						item.imagePath
					]);
					return "";
				});
			}

			//var currentSpecImage = this.state.currentSpecImage;
			var lastNum = this.state.lastNum;
			var imgwidthvary = this.state.imgwidthvary;
			var movedOver = this.state.movedOver;
			var wasBackwards = this.state.wasBackwards;
			var startOver = this.state.startOver;
			var moveOver = this.state.moveOver;

			var allimgs = productImagesArray.length;
			var trueimglength = allimgs*81;

			/* Scroll the overflow DIV */

			//alert('num: ' + num + ' lastNum: ' + lastNum + ' imgwidthvary: ' + imgwidthvary + ' trueimglength: ' + trueimglength);

			// Did the user click the right arrow, and there's more than 4 images?

			if (num === lastNum + 1 && allimgs > 4) {

				// Is the current number equal to or greater than 3?
				if (num >= 3 && num < allimgs) {

					/* Is imgwidthvary less than 1? If so, set it back to 81 (the width of an image container) */
					if (imgwidthvary < 1) {
						imgwidthvary = 81;
					}

					// Were we going backwards before this?

					if (wasBackwards === true) {
						if (typeof moveOver === "undefined")  {
							moveOver = 0;
						}

						imgwidthvary = 0;
						imgwidthvary = moveOver + 81;


						moveOver += 81;
						$('#thumbnailsViewer').stop().animate({ right: moveOver + 'px' }, 600);
					} else {
						$('#thumbnailsViewer').stop().animate({ right: imgwidthvary + 'px' }, 600);
						imgwidthvary += 81;
					}

					movedOver = true;

				}
				else if (num === allimgs) {
					$('#thumbnailsViewer').stop().animate({ right: '0' }, 400);
					movedOver = false;
					moveOver = 0;
					wasBackwards = false;
					imgwidthvary = 81;
					startOver = true;
				}
			}

			// Did the user click the left arrow, and there's more than 4 images?

			else if (num === lastNum - 1 && allimgs > 4) {

				// Did the user click the left arrow right away?
				if (num < 0) {
					moveOver = trueimglength - 243;
					$('#thumbnailsViewer').stop().animate({ right: moveOver + 'px' }, 600);
					movedOver = false;
					wasBackwards = false;
					imgwidthvary = 81;
					startOver = false;
				}
				else if (num >= 3 && num < allimgs) {
					if (imgwidthvary >= 81) {
						if (typeof moveOver === "undefined" || startOver === true)  {
							moveOver = 0;
							moveOver = trueimglength - 81;
							imgwidthvary -= 81;
							startOver = false;
						}
					}

					wasBackwards = true;

					if (movedOver === true) {
						moveOver = imgwidthvary;
						moveOver -= 81;
						$('#thumbnailsViewer').stop().animate({ right: imgwidthvary + 'px' }, 600);
						imgwidthvary -= 81;
						//alert('movedOver true');
					} else {
						$('#thumbnailsViewer').stop().animate({ right: moveOver + 'px' }, 600);
						//alert('moving by: ' + moveOver + 'px');
						moveOver -= 81;
					}
				}
				else if (num === 2) {
					$('#thumbnailsViewer').stop().animate({ right: '0' }, 600);
					movedOver = false;
					moveOver = 0;
					wasBackwards = false;
					imgwidthvary = 81;
					startOver = true;
				}
				else if (movedOver === true) {
					$('#thumbnailsViewer').stop().animate({ right: '0' }, 600);
					movedOver = false;
					moveOver = 0;
					wasBackwards = false;
					imgwidthvary = 81;
					startOver = true;
				}
			}

			// check the limits

			if( num < 0 ) {
				num = productImagesArray.length - 1;
			}

			if( num >= productImagesArray.length ) {
				num = 0;
			}

			lastNum = num;

			// set selected thumbnail

			$('#thumbnailViewerMain').find('img.selected').removeClass('selected');
			$("#thumbnailViewerMain #productThumbnail"+num).find('img').addClass('selected');
			// document.getElementById("productThumbnail"+this.state.currentSpecImage ).childNodes[0].className = "";
			// document.getElementById("productThumbnail"+num ).childNodes[0].className = "selected";

			this.setState({
				lastNum: lastNum,
				currentSpecImage: num,
				movedOver: movedOver,
				moveOver: moveOver,
				wasBackwards: wasBackwards,
				imgwidthvary: imgwidthvary,
				startOver: startOver
			}, () => {
				//Set Large zoom image
				this.setMainImage(allImages, num);
			});
		});
	}

    componentWillReceiveProps(nextProps) {
		const self = this;
        if(nextProps.params.sku !== self.props.params.sku) {
            self.setState({
                isLargeImageSetOnLoad: false,
                isToolTipSet: false
            });
			//Always set first tab active in case of any product is clicked in accessories and it has no accessories
			self.toggle(1, null);
			self.props.getProductSpecs(`requestType=spec&sku=${nextProps.params.sku}`, (response) => {
				self.updateStoreWithUpdatedSpecsData(response);
			});
        }

		// update local state with zipcode, this is useful when page is getting refreshed
		if (
			!self.state.isPrelogin && ((self.props.customZipCode && nextProps.customZipCode && self.props.customZipCode !== nextProps.customZipCode) ||
			(!nextProps.isGEAPartsSalesAgreementSelected() && self.props.customADC && nextProps.customADC && self.props.customADC !== nextProps.customADC))
		) {
			self.updateAvailability(nextProps.customZipCode, nextProps.customADC);
		}
    }

	setMainImage(allImages, num) {
		var productImagesArray = this.state.productImagesArray;

		if(!productImagesArray) {
			productImagesArray = [];
			allImages.map((item) => {
				productImagesArray.push([
					item.imagePath,
					item.imagePath,
					item.imagePath
				]);
				return "";
			});
		}

		var mainImageSrc = num===0&&!this.state.setMainImageFlg?allImages.filter((itm)=>{return itm.defaultImage == true})[0].imagePath:productImagesArray[num][2],
			anchorContents,
			anchorContentsMagicZoomImage = num===0&&!this.state.setMainImageFlg? allImages.filter((itm)=>{return itm.defaultImage == true})[0].imagePath:productImagesArray[num][2];

		if(this.state.mainImageSrc === "") {
			mainImageSrc = allImages.filter((itm)=>{return itm.defaultImage == true})[0].imagePath;
			anchorContentsMagicZoomImage = allImages.filter((itm)=>{return itm.defaultImage == true})[0].imagePath;
		}

		this.setState({
			mainImageSrc: mainImageSrc,
			isLargeImageSetOnLoad: true
		});

		if(!anchorContentsMagicZoomImage) {
			anchorContents = "";
			document.getElementById("magnifyInstructions").style.visibility = "hidden";
		}else {
			anchorContents = " class=\"MagicZoomPlus\" rel=\"zoom-position:inner;zoom-fade: true; buttons:hide;\" href=\"" + anchorContentsMagicZoomImage + "\"";
			document.getElementById("magnifyInstructions").style.visibility = "visible";
		}
		document.getElementById("imageCell").innerHTML = "<a" + anchorContents + "><img id=\"mainImage\" src=\"" + mainImageSrc + "\" width=\"480\" height=\"500\" alt=\"\" title=\"\" /></a>";

		// write the main image for the printer CSS. The DIV is hidden unless the printer CSS is loaded

		document.getElementById("productImgforPrint").innerHTML = "<img src=\"" + mainImageSrc + "\" width=\"288\" height=\"300\" alt=\"Product image for print\" title=\"Product image for print\" />";

		setTimeout(() => {
			window.activateMagicZoom();
		}, 1000);
	}

    toggleCollapseExpand(event) {
		event.preventDefault();
		$(event.currentTarget).toggleClass("active");
		$(event.currentTarget).next().slideToggle();
	}

	printPDF(event) {
		event.preventDefault();
		let { state } = this.props;
		this.props.printSpecsPDF(`sku=${state.product.productSpecs.responseObject.sku}`, (response) => {
			if(response.status) {
				//PDF will be opened in new window
				window.open(response.responseObject);
			} else {
				browserHistory.push("/error");
			}
		});
	}

	setPairingModelToolTipSet(flag) {
		this.setState({
			isPairingModelsMsrpSet: flag
		})
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		var self = this;
		let { product } = self.props.state;
		if(product && product.productSpecs && product.productSpecs.responseObject && product.productSpecs.responseObject !== 'NA') {
		var productSpecsData = null;
		productSpecsData = product.productSpecs.responseObject;
		productSpecsData.images = [];
		self.props.saveProductSpecs(productSpecsData);
		}
		self.setState({
			specURL: window.location.pathname,
			isPrelogin: window.location.pathname.indexOf("/prelogin/")===0?true:false,
			basePath: window.location.pathname.indexOf("/prelogin/")===0?'/prelogin':''
		}, () => {
			self.props.getProductSpecs(`requestType=spec&sku=${self.props.params.sku}`, (response) => {
				self.updateStoreWithUpdatedSpecsData(response);
				if(response && response.responseObject && response.responseObject.relationships){
					let accessories=_.find(response.responseObject.relationships, ["name", "Accessories_"]);
					let accessoriesKit = _.find(response.responseObject.relationships, ["name", "Accessories Kit_"]);
					if(accessories || accessoriesKit || (response && response.responseObject && response.responseObject.optionalCharge) ){
						let itemForApi=``;
						accessories && accessories.items.map((item, index)=>{
						itemForApi = itemForApi + item.sku + ` `;
						});
						accessoriesKit && accessoriesKit.items.map((item, index)=>{
							itemForApi = itemForApi + item.sku + ` `;
						});
						if(response.responseObject.optionalCharge || response.responseObject.optionalCharge!==null){				
						itemForApi = itemForApi + response.responseObject.optionalCharge.replaceAll("|", " ");
						}
						let arr = itemForApi.split(" ");
						itemForApi = Array.from(new Set(arr)).toString().replaceAll(",", " ")
						self.props.getProductSpecs(`skus=${itemForApi}`, (resp) => {
							this.setState({
								accessoriesItem: (accessories || accessoriesKit || (response && response.responseObject && response.responseObject.optionalCharge)) ? resp.responseObject : ''
							})
						});
					}}
		});
		});
		//Add external javascript file for MagicZoomPlus
		const script = document.createElement("script");
        script.src = "/scripts/magiczoomplus.js";
        script.async = true;
        document.body.appendChild(script);
    }

	updateStoreWithUpdatedSpecsData(response) {
		var self = this;
		let productSpecsData = self.props.manipulateProductSpecsData(response);

		//set overall capacity
		let overallDimensions = _.find(productSpecsData.responseObject.attributes,["displayName", "Total Capacity (cubic feet)"]),
		    overallCapacity = 0.0;
		if(overallDimensions && overallDimensions.displayName ===  "Total Capacity (cubic feet)" ){
			overallCapacity = overallDimensions ? parseFloat(overallDimensions.values[0].value).toFixed(2) : '';
		}

		//set accessories
		let accessories = productSpecsData.responseObject.relationships ? productSpecsData.responseObject.relationships : null;
		accessories = _.find(accessories, ["name", "Accessories_"]);
		accessories = accessories && accessories.items;

		let productHeight = 0,
			productWidth = 0,
			productDepth = 0,
			productDimensions = productSpecsData.responseObject.dimensions;

		// set dimensions and its height
		if(productDimensions && productDimensions.length > 0) {
			productDimensions = productDimensions.toString().split("x");
			productHeight =  productDimensions[0] && productDimensions[0].split("H");
			productWidth =   productDimensions[1] && productDimensions[1].split("W");
			productDepth =   productDimensions[2] && productDimensions[2].split("D");
		}

		// set cross color
		let cross_Sell_Colors = productSpecsData.relationships ? productSpecsData.relationships : null;
		cross_Sell_Colors = _.find(cross_Sell_Colors,["name", "Cross Sell Colors_"]);
		cross_Sell_Colors = cross_Sell_Colors && cross_Sell_Colors.items;

		// set related products
		let pairing_Models = productSpecsData.relationships ? productSpecsData.relationships : null;
		pairing_Models = _.find(pairing_Models,["name", "Pairing Models_"]);
		pairing_Models = pairing_Models && pairing_Models.items;

		//Update responseObject with all manipulated values so it will be easy while rendering
		productSpecsData.responseObject = {
			...productSpecsData.responseObject,
			//set price
			productPrice: productSpecsData.responseObject.msrp && parseFloat(productSpecsData.responseObject.msrp).toFixed(2),
			//set accessories
			accessories,
			//Set claims
			claims: _.find(productSpecsData.responseObject.attributes,["displayName", "Claims & Certifications"]),
			//Set Documents link
			quickSpecsLink: self.getLinkOfDocumentByName(productSpecsData.responseObject.documents, "Quick Specs"),
			energyGuideLink: self.getLinkOfDocumentByName(productSpecsData.responseObject.documents, "Energy Guide"),
			ownersManualLink: self.getLinkOfDocumentByName(productSpecsData.responseObject.documents, "Use and Care Manual"),
			installationInstructionLink: self.getLinkOfDocumentByName(productSpecsData.responseObject.documents, "Installation Instructions"),
			//Set overall capacity
			overallCapacity,
			// set dimensions and its height
			productHeight,
			productWidth,
			productDepth,
			// set video link of feature copy
			videos: productSpecsData.responseObject.featureCopy.filter((item)=>{
				return item.bctId
			}),
			// set cross color
			cross_Sell_Colors,
			// set related products
			pairing_Models
		};
		self.setState({
			productSpecsData
		}, () => {
			self.updateAvailability(self.props.customZipCode, self.props.customADC);
			self.props.saveProductSpecs(productSpecsData);
		});
	}

	updateAvailability(zip, adc, callback) {
		const self = this;
		const { productSpecsData } = self.state;
		// populate below undefined fields
		const {
			brand,
			category,
			description,
			firstDistributionDate,
			finalProductionDate,
			partAccessory
		} = (productSpecsData && productSpecsData.responseObject) || {};
		if (!this.state.isPrelogin && self.props.isGEAPartsSalesAgreementSelected() && partAccessory) {
			const isPimRequired = self.state.pim === undefined;
			const isPricingRequired = self.state.pricing === undefined;

			self.props.getItemDetails({
				items: [{
					itemNumber: self.props.params.sku.toUpperCase()
				}]
			}, data => {
				if (data.items && data.items[0]) {
					const newState = {
						availability: data.items[0].availabilityData || null,
						isRestricted: data.items[0].isRestricted,
						restrictionReason: data.items[0].restrictionReason
					}
					if (isPimRequired) {
						newState.pim = data.items[0].pimData || null;
					}
					if (isPricingRequired) {
						newState.pricing = data.items[0].pricingData || null;
					}
					if (isPimRequired && isPricingRequired) {
						newState.isVolumeDiscountEligible = data.items[0].isVolumeDiscountEligible;
					}
					self.setState(newState);
				}
			}, {
				searchContext: 'PNET',
				include: {
					availability: true,
					orderability: true,
					pim: isPimRequired,
					pricing: isPricingRequired
				},
				showLoader: true
			})
		} else {
			const zipCode = self.state.isPrelogin ? self.props.getZipCode() : zip;
			const skuList = [{'sku': self.props.params.sku}];
			self.props.getShippingAddressesDetails(zipCode, true, 'adc_loc', resp => {
				if(resp && resp.agentid) {
					self.props.checkAvailabilityAndOrderability(skuList, `accountNumber=${self.props.getSelectedAccountNumber()}&zipCode=${zipCode}&legacyCustCode=${self.props.legacyCustCode}&warehouseCode=${self.state.isPrelogin ? resp.agentid : adc}${self.state.isPrelogin ? '' : this.props.getSalesAgreementParamForAvailability()}`, self.state.isPrelogin ? self.props.getSelectedAddressParams() : '', '', true, response => {
						if(response && response.responseObject && response.responseObject.length) {
							let item = response.responseObject[0];
							item = {
								...item,
								firstDistributionDate: firstDistributionDate,
								finalProductionDate: finalProductionDate,
							};
							let data = {
								availableQty: item.availableQty,
								intransitQty: item.intransitQty,
								etaDate: item.etaDate,
							};
							if(self.props.checkIfFP(item)) {
								data.intransitQty = null;
								data.etaDate = 'FP';
							} else {
								data = self.props.validateFDD(item);
							}
							response.responseObject[0] = {
								...item,
								...data
							};
						} else {
							response.responseObject = null;
						}
						self.setState({
							availability: response,
						}, () => {
							callback && callback();
							self.props.fireGTMTag('Product Details Page', {
								ecommerce: {
									currencyCode: 'USD',
									detail: {
										actionField: {},
										products: [{
											name: description,
											id: self.props.params.sku,
											price: productSpecsData.responseObject.productPrice,
											brand,
											category,
											variant: undefined,
											dimension70: response.responseObject && response.responseObject[0] && response.responseObject[0].availableQty
										}]
									}
								}
							});
						});
					});
				}
			});
		}
	}

	handleAvailabilityDetails(event) {
		event.preventDefault();
		const self = this;
		if (!self.state.availability) {
			self.updateAvailability(self.props.customZipCode, self.props.customADC, () => {
				self.handleDialog("AvailabilityDetailsOverlayDialog", true);
			});
		} else {
			self.handleDialog("AvailabilityDetailsOverlayDialog", true);
		}
	}

    render() {
		var self = this;
		let { product } = self.props.state;
		let accessoriesItem = self.state.accessoriesItem;
		var productSpecsData = null;
		const isGEAPartsSalesAgreementSelected = !this.state.isPrelogin && this.props.isGEAPartsSalesAgreementSelected();
		if(product && product.productSpecs && product.productSpecs.responseObject && product.productSpecs.responseObject !== 'NA') {

			/*Final Code stars*/
			productSpecsData = product.productSpecs.responseObject;

            setTimeout(() => {
				if(self.state.isToolTipSet === false) {
					self.setToolTip();
				}
            }, 2000);

            if(productSpecsData.pairing_Models && !this.state.isPairingModelsMsrpSet){
                 // productSpecsData.pairing_Models.map((item,index)=>{
                 //     self.fetchProductSpecsMSRP(item.sku)
                 //     return null
                 // })
				 self.setPairingModelToolTipSet(true);
             }
            /*Final Code ends*/

			if(!self.state.isLargeImageSetOnLoad) {
				setTimeout(function(){
					self.setMainImage(productSpecsData.images, 0);
				}, 2000);
			}
		}
        let sku = [],
        wishListSku = [];
        //for gettting current cart object
        if(this.props.state.cart&&this.props.state.cart.cart&&this.props.state.cart.cart.cartItems&&this.props.state.cart.cart.cartItems.length>0){
            let {cart} = this.props.state.cart,
            cartItems = cart.cartItems;
            //sku = [];
            cartItems.map((item,index)=>{
                sku.push(item.product);
                return null
            });
        }
        //for gettting current List object
        if(this.props.state.list&&this.props.state.list.list&&this.props.state.list.list.wishlistItems&&this.props.state.list.list.wishlistItems.length>0){
            let {list} = this.props.state.list,
            wishlistItems = list.wishlistItems;
            //sku = [];
            wishlistItems.map((item,index)=>{
                wishListSku.push(item.item);
                return null
            });
        }

        return (
			<div className="specPageContent">
				{product && product.productSpecs && product.productSpecs.responseObject && product.productSpecs.responseObject !== 'NA'
					?<div>
						{productSpecsData?
							<div>
				                <table cellPadding={0} cellSpacing={0} id="specMainLayoutTable" summary="Main layout table">
				                    <tbody>
				                        <tr>
				                            <td className="leftCol">
				                                {/* Start #mainImageViewer */}
				                                <table cellPadding={0} cellSpacing={0} id="mainImageViewer" summary="Main image viewer">
				                                    <tbody>
				                                        <tr>
				                                            <td id="imageCell">
				                                            </td>
				                                        </tr>
				                                    </tbody>
				                                </table>
				                                {/* end #mainImageViewer */}
				                                <div id="magnifyInstructions" style={{visibility: 'hidden'}}></div>
				                                {/* Start image for PRINTING ONLY (hidden on screen, shows on print) */}
				                                <div id="productImgforPrint">
				                                </div>
				                                {/* End image for PRINTING ONLY (hidden on screen, shows on print) */}
				                                <div id="shareSection">
				                                    {/* Start "share" section */}
				                                    {/* GEA's global masthead contains the necessary javascript. */}
				                                    {/* For pages w/o masthead, a different chunk needs to be used. */}
				                                    <div className="social-share-container addthis_toolbox addthis_default_style addthis_32x32_style">
														<PinterestShareButton
															url={window.location.href}
															media={this.state.mainImageSrc}
															windowWidth={1000}
															windowHeight={730}
															className="social-icon product-specs-share-pi-icon">
															<PinterestIcon size={this.state.socialIconSize} round={false} />
														</PinterestShareButton>

														<FacebookShareButton
															url={window.location.href}
															className="social-icon product-specs-share-fb-icon">
															<FacebookIcon size={this.state.socialIconSize} round={false} />
														</FacebookShareButton>

														<TwitterShareButton
															url={window.location.href}
															className="social-icon product-specs-share-tw-icon">
															<TwitterIcon size={this.state.socialIconSize} round={false} />
														</TwitterShareButton>

														<GooglePlusShareButton
															url={window.location.href}
															className="social-icon product-specs-share-gp-icon">
															<GooglePlusIcon size={this.state.socialIconSize} round={false} />
														</GooglePlusShareButton>

				                                        <a href="mailto:" className="addthis_button_email"><img src={geUrlImageRootImages+"/common/24-email.gif"} width={24} height={24} alt="Share via email" /></a>
				                                    </div>
				                                </div>
				                                {/* End "share" section */}
				                            </td>
				                            <td className="rightCol">
				                                <table cellPadding={0} cellSpacing={0} summary="Product information container">
				                              		<tbody>
					                                	<tr>
						                                  	<td>
							                                    {/* Start brand logo */}
							                                    {productSpecsData.brandImagePath && <div className="brandLogo"><img src={productSpecsData.brandImagePath} width={95} height={28} title={productSpecsData.brand} alt='' /></div>}
							                                    {/* End brand logo */}
							                                    {/*googleoff: all*/}
							                                    {/* Start printer-friendly link */}
							                                    <div className="floatRight" id="printFriendly"><a href="" onClick={this.printPDF.bind(this)}><img src={geUrlImageRootImages+"/common/icon_print.gif"} width={16} height={17} alt="Printer-friendly page" title="Printer-friendly page" />Printer-Friendly Page</a></div>
							                                    {/*googleon: all*/}
							                                    <div className="clear"></div>
							                                    <br />
							                                    {/* End printer-friendly link */}
							                                    {/* Start product name/model */}
							                                    {/* CNET CHANGE HERE: move h1.SKUonspec above h1.model */}
							                                    <h1 id="SKUonspec">{productSpecsData.sku}</h1>
							                                    <h1 id="model">{productSpecsData.description}</h1>
							                                    {/* CNET CHANGE HERE: remove reviews */}
							                                    {/*<div id="BVRRSummaryContainer"></div>*/}
							                                    {/* End product name/model */}
							                                    {/* Start infoBlock */}
							                                    {(!isGEAPartsSalesAgreementSelected || !this.state.isRestricted) && <div className="infoBlock">
							                                      	{!this.state.isPrelogin && isGEAPartsSalesAgreementSelected && productSpecsData.partAccessory ?
																	this.state.pricing && this.state.pricing.records && this.state.pricing.records[0] && <div className="flex" style={{columnGap: '2rem'}}>
																		<p>
																			<b style={{color: '#9a9a9a', fontSize: '.75rem'}}>Book Price</b><br />
																			<span id="priceDollarsign">$</span><span id="price">{this.state.pricing.records[0].unitPrice}</span>
																		</p>
																		<p>
																			<b style={{color: '#9a9a9a', fontSize: '.75rem'}}>Selling Price</b><br />
																			<span id="priceDollarsign">$</span><span id="price">{this.state.pricing.records[0].adjustedUnitPrice}</span>
																		</p>
																		<p>
																			<b style={{color: '#9a9a9a', fontSize: '.75rem'}}>Volume Discount Eligible?</b><br />
																			<strong>{this.state.isVolumeDiscountEligible ? 'Yes' : 'No'}</strong>
																		</p>
																	</div>:
																	<table cellPadding={0} cellSpacing={0} id="productCalltoActionTable" summary="GE product information">
							                                        	<tbody>
																			<tr>
							                                            		<td>
																					{/* Start price */}
																					<span id="priceDollarsign">$</span><span id="price">{productSpecsData.productPrice}</span> <a href="" onClick={this.handleDialog.bind(this, "EstRetailPriceTooltipOverlayDialog", true)}>MSRP</a>
																					{/* End price */}
																					{/* CNET CHANGE HERE: remove buy button from here. Will add below. */}
							                                            		</td>
									                                            {/* Start rebates and promotions link */}
									                                            {/* End rebates and promotions link */}
									                                            {/* Start ratings and reviews section */}
							                                            		<td>
							                                              		</td>
							                                            		{/* End ratings and reviews section */}
							                                          		</tr>
							                                        	</tbody>
																	</table>}
							                                      	{/* CNET CHANGE HERE: addition. */}
																	<div className="specPageCustomerNetSpecial">
																		<div className="leftSide">
																			{/* !this.state.isPrelogin?
																				<AddToCart item={productSpecsData.sku} itemDescription={productSpecsData.description}  itemType={productSpecsData.itemType}/>
																			:null}
																			{!this.state.isPrelogin?
																				<AddToList item={productSpecsData.sku} itemDescription={productSpecsData.description}  itemType={productSpecsData.itemType}/>
																			:null */}
																		</div>
																		<div className="rightSide">
																			<p><a className="availabilityDetailsLink" href="" onClick={this.handleAvailabilityDetails.bind(this)}>Availability Details</a></p>
																		</div>
																	</div>
							                                    </div>}
							                                    {/* end infoBlock */}
							                                    {/* BEGIN EcoRebates Widget */}
																{/*!this.state.isPrelogin?
								                                    <div id="rebateFormatTop" className="rebateFormatTop">
								                                    	<span style={{fontSize: 18, fontWeight: 'bold', textTransform: 'uppercase', color: 'black'}}>$ </span>
								                                    	<span style={{fontSize: 14, textTransform: 'uppercase'}}>REBATES &amp; PROMOTIONS</span><br /><br />
								                                    	<div id="ecorebatesTop" className="ecorebates" style={{backgroundColor: '#EEEEEF'}}>
								                                    	</div>
								                                    </div>
																:null*/}
							                                    <br />
						                                    	{/* END EcoRebates Widget */}
							                                    <table cellPadding={0} cellSpacing={0} id="productQuickInfoTable" summary="GE further product information">
							                                      	<tbody>
																	  	<tr>
							                                                {productSpecsData.productHeight.length > 0?
								                                                <td width="70%">
									                                            	<span className="head">APPROXIMATE DIMENSIONS (HxWxD)</span>
									                                            	<br />
									                                            	<p className="data">{productSpecsData.dimensions} in</p>
									                                          	</td>
																			:null}
								                                        </tr>
								                                        <tr>
							                                                {productSpecsData.overallCapacity?
									                                          	<td colSpan={2}>
									                                            	<div className="floatLeft">
										                                              	<span className="head">TOTAL CAPACITY</span>
										                                              	<br />
										                                              	<p className="data">{productSpecsData.overallCapacity} cu ft</p>
									                                            	</div>
									                                          	</td>
																			:null}
								                                        </tr>
							                                        	<tr>
								                                          	<td colSpan={2}>
									                                            {/* Available colors section */}
							                                                    {productSpecsData && productSpecsData.cross_Sell_Colors && productSpecsData.cross_Sell_Colors.length > 0
							                                                        ?<span className="head">AVAILABLE COLORS</span>
							                                                        :null
							                                                    }
									                                            <br />

									                                            <div id="availableColors" className="floatLeft"  >
							                                                        {productSpecsData.cross_Sell_Colors && productSpecsData.cross_Sell_Colors.map((item, index) => {
							                                                            if(item.sku){
																							var msrpData = _.find(product.productSpecsMSRP, ["sku", item.sku]);
							                                                                var self=this;
							                                                                let colorName=item.colorName.replace(" ",'-').toLowerCase();
							                                                                let finalcolorName = "swatch-block swatch-"+colorName;
							                                                                return <div className="newTooltip" key={index}>
							                                                                    <a href={self.state.basePath+"/product-specs/"+self.props.params.typeOfSearch+"/"+item.sku} className="trigger" alt={item.colorName} title={item.colorName}><span className={finalcolorName}></span></a>
							                                                                    <div className="popup" key={index}>
								                                                                    <div key={index}>
																									<img src={item.imagePath} width={96} height={100} alt={item.colorName} title={item.colorName} className="floatLeft" style={{margin: '0 7px 0 0'}} />
							                                                                            <Link to={this.state.basePath+"/product-specs/"+this.props.params.typeOfSearch+"/"+item.sku} >
							                                                                             {item.description}</Link><br />
								                                                                        <span>{item.sku}</span>
								                                                                        <br />
								                                                                        <span>{msrpData?"$"+msrpData.msrp:null}</span> <span style={{fontSize: 8}}>MSRP</span>
								                                                                    </div>
							    		                                                     	</div>
																							</div>
							                                                        	}
																						return null
							                                                    	})}
								                                              		{/* end color tooltip */}
									                                            </div>

									                                            {/* End available colors section */}
									                                            {/* Custom panels section */}
									                                            {/* End custom panels section */}
								                                          	</td>
							                                        	</tr>
						                                      		</tbody>
																</table>
						                                    	<div className="clear"></div>
					                                  		</td>
					                                	</tr>
						                                <tr>
						                                	<td style={{verticalAlign: 'bottom', width: 390}}>
						                                    	<div id="thumbnailViewerMain">
							                                      	<a href="" onClick={this.newSetMainImage.bind(this, this.state.currentSpecImage-1, productSpecsData.images)}><img src={geUrlImageRootImages+"/common/viewer_previous.gif"} width={22} height={70} alt="Previous" title="Previous" style={{position: 'absolute', top: 4, left: 0, zIndex: 1}} /></a>
							                                      	<div id="thumbnailViewerWrapper">
							                                        	<ul id="thumbnailsViewer">
					                                                    	{productSpecsData.images.map((item, index) => {
					                                                        	return <li key={index}>
					                                                            	<a href="" id={"productThumbnail"+index} onClick={self.newSetMainImage.bind(this, index, productSpecsData.images)}> <img src={item.imagePath} width="60" height="63" alt="View larger" title="View larger" /></a>
					                                                    		</li>
																			})}
					                                                	</ul>
							                                      	</div>
							                                      	<a href="" onClick={this.newSetMainImage.bind(this, this.state.currentSpecImage+1, productSpecsData.images)}><img src={geUrlImageRootImages+"/common/viewer_next.gif"} width={22} height={70} alt="Next" title="Next" style={{position: 'absolute', top: 4, right: 0}} /></a>
							                                    </div>
							                                </td>
						                                </tr>
				                            		</tbody>
				                            	</table>
				                            </td>
				                        </tr>
				                    </tbody>
				                </table>
				                {/* end #specMainLayoutTable */}
				                {/* Start tabs section */}
				                <div style={{position: 'relative', margin: 0}}>
				                  	{/* This DIV is here to place the faux gray bar all the way across the layout */}
				                  	<div id="fauxBar"></div>
									{/* End faux DIV */}
									{/* Start tab navigation menu */}
									<ul className="tabs">
										<li id="tab1_top" className="active"><a onClick={this.toggle.bind(this,1)} href="">Overview</a></li>
										<li id="tab2_top"><a onClick={this.toggle.bind(this,2)} href="">Product Details</a></li>
										<li id="tab3_top"><a onClick={this.toggle.bind(this,3)} href="">Manuals / Downloads</a></li>
										{((productSpecsData.pairing_Models && productSpecsData.pairing_Models.length > 0) || (productSpecsData.accessories && productSpecsData.accessories.length > 0) || (productSpecsData.optionalCharge))
											?<li id="tab6_top"><a onClick={this.toggle.bind(this,6)} href="">Related Products / Accessories</a></li>
											:null
										}
									</ul>
									<div className="tab_container">
										<div style={{display: 'block'}} className="tab_content" id="tab1">
		                                    {(productSpecsData.videos.length > 0) &&
		                                    <div>
		    									{/* BEGIN: CONTENTS OF NEW OVERVIEW TAB (RITM0076442) */}
		    									{/* BEGIN: OPTIONAL PRODUCT HIGHLIGHTS SECTION (RITM0076442) */}
		    									<div className="lightStrokeB sectionPush">
		    										<h3>Product Highlights</h3>
		    									</div>
		    									{/* CNET CHANGE HERE: Remove the following image from the "Play Video" links:
		    									<img src={geUrlImageRootImages+"/common/small_blue_right_arrow.gif" width="14" height="10" alt="Play Video" title="Play Video"/>
		    									*/}
		    			                        <div className="specPageProductHighlightContainer lightStrokeB sectionPush">
		                                            {productSpecsData.videos.map((item, index) => {
		                                            let values = item.featureCopy+'';
													if(values.includes("href"))
													{
														values = values.replace(/href=([^"'\s]+)/g,'href="$1"');
														const parse = new DOMParser().parseFromString(values,'text/html');
														const link = parse.querySelector('a');
														const text = link.href.length>0 ? link.previousSibling?link.previousSibling.textContent.trim():'':'';
														const href = link.href.length>0 ? link.href:'';
														const urlText = link.href.length>0 ? link.textContent.length>0 ? link.textContent.trim():'':'';
														const AfterHrefText = link.href.length>0 ? link.nextSibling ? link.nextSibling.textContent.trim():'':'';
													   
														return (index < 4&&item.bctImage) ? <div key={index} className="specPageProductHighlight">
														<p><a className="playButton" href={item.bctId} target="_blank"><img src={item.thumbnail} width={185} height={193} alt="" /><span className="sprite" /></a></p>
														<p><strong>{item.feature}</strong><br />
														{<span>{text + " "}</span>}
														{link.href.length>0 ?<a href={href} target='_blank' style={{textDecoration:"underline"}}>{urlText}</a> : item.featureCopy} 
														{<span>{" " + AfterHrefText}</span>}
														<br /><a className="playButton" href={item.bctId} target="_blank">Play Video</a></p>
													    </div>
														:null }
													else{
														return (index < 4&&item.bctImage) ? <div key={index} className="specPageProductHighlight">
														<p><a className="playButton" href={item.bctId} target="_blank"><img src={item.thumbnail} width={185} height={193} alt="" /><span className="sprite" /></a></p>
		                                                <p><strong>{item.feature}</strong><br />{item.featureCopy}<br /><a className="playButton" href={item.bctId} target="_blank">Play Video</a></p>
		        				                        </div>
		                                                :null
													}
		                                            })}
		    				                        <div className="clear"></div>
		    			                        </div>
		    		                      		{/* END: OPTIONAL PRODUCT HIGHLIGHTS SECTION (RITM0076442) */}
		                                    </div>}
				                      		<table className="threeColumnTable specPageOverviewThreeColumnTable" cellPadding={0} cellSpacing={0} id="tabletab1" style={{width: '100%'}}>
				                        		<tbody>
				                          			<tr>
				                            			<td className="specPageOverviewFeaturesCell">
				                              				<div className="sectionPush">
				                            					<h3 className="inspira">Features</h3>
			                              					</div>
														  	<ul className="spaced dot">
																{productSpecsData.featureCopy.map((item, index) => {
																let values = item.featureCopy+'';
																if(values.includes("href")){
																	values = values.replace(/href=([^"'\s]+)/g,'href="$1"');
																	const parse = new DOMParser().parseFromString(values,'text/html');
																	const link = parse.querySelector('a');
																	const text = link.href.length>0 ? link.previousSibling?link.previousSibling.textContent.trim():'':'';
																	const href = link.href.length>0 ? link.href:'';
																	const urlText = link.href.length>0 ? link.textContent.length>0 ? link.textContent.trim():'':'';
																	const AfterHrefText = link.href.length>0 ? link.nextSibling ? link.nextSibling.textContent.trim():'':'';

																	if(index > 4) return null;
																		return <li key={index}>
																		<strong>{item.feature}</strong>
																		{item.feature && item.feature.length > 0?<br />:null}
																		{<span>{text + " "}</span>}
																		{link.href.length>0 ?<a href={href} target='_blank' style={{textDecoration:"underline"}}>{urlText}</a> : item.featureCopy} 
																		{<span>{" "+ AfterHrefText}</span>}
																		</li>
																}
																else{
																	if(index > 4) return null;
																	return <li key={index}>
																	<strong>{item.feature}</strong>
																	{item.feature && item.feature.length > 0?<br />:null}
																	{item.featureCopy}
																	</li>
																}
																})}
							                              	</ul>
				                              				<br />
								                            <p>
								                                {/* CNET CHANGE HERE: change "blueBtn" to "blueButton".  Change "More Product Details &#8250;" to say "More Product Details". */}
								                                <a style={{display: 'inline-block', fontSize: 16}} className="blueButton external_link" href="" onClick={this.toggle.bind(this, 2)}>More Product Details</a>
								                            </p>
								                            {/* CNET CHANGE HERE: remove div.buyButtonsDiv. */}
								                            {/*<div class="buyButtonsDiv">
																	<a class="greenBtn" href={geUrlImageRootImages+"/buy/" style="display: inline-block; font-size: 16px;">Where to Buy &#8250;</a>
																	<!- - End where to buy button - ->
																</div>
															*/}
								                            {/* BEGIN: *OPTIONAL* CLAIMS AND CERTIFICATIONS TABLE CELL */}
				                            			</td>
				                            			{/* BEGIN: *OPTIONAL* CLAIMS AND CERTIFICATIONS TABLE CELL */}
														{this.checkArrayContainsWord(productSpecsData.claims, "ENERGY STAR") || this.checkArrayContainsWord(productSpecsData.claims, "MADE IN AMERICA")
															?<td className="specPageOverviewClaimsAndCertificationsCell">
								                              	<div className="sectionPush">
									                                <h3 className="inspira">Claims &amp; Certifications</h3>
								                              	</div>
								                              	<div className="sectionPush">
																	{this.checkArrayContainsWord(productSpecsData.claims, "ENERGY STAR")
																		?<div className="specPageClaimOrCertification">
																			<p className="image">
																				<img src={geUrlImageMigratedAssets+"/images/common/logos/logo-energy_star.gif"} width={48} height={48} alt="ENERGY STAR® Qualified" title="ENERGY STAR® Qualified" />
																			</p>
																			<p className="text">
																				<strong>ENERGY STAR® Qualified</strong><br />
																				Meets the ENERGY STAR energy efficiency requirements.
																			</p>
																			<div className="clear"></div>
																		</div>
																		:null
																	}
																	{this.checkArrayContainsWord(productSpecsData.claims, "Produced In Our American Manufacturing Plants")
																		?<div className="specPageClaimOrCertification">
										                                  	<p className="image">
										                                    	<img src={geUrlImageMigratedAssets+"/images/common/logos/logo-america_at_work.png"} width={49} height={48} alt="Produced In Our American Manufacturing Plants" title="Produced In Our American Manufacturing Plants" />
										                                  	</p>
										                                  	<p className="text">
											                                    <strong>Produced In Our American Manufacturing Plants</strong>
										                                  	</p>
										                                  	<div className="clear"></div>
										                                </div>
																		:null
																	}
								                              	</div>
								                            </td>
															:null
														}
							                            {/* END: *OPTIONAL* CLAIMS AND CERTIFICATIONS TABLE CELL */}
							                            <td className="specPageOverviewRightHandCell hideForPrint">
							                              	<div className="sectionPush">
								                                <h3 className="inspira">Quick Links</h3>
								                                {/* BEGIN: EXISTING CONTENT NOT MODIFIED */}
								                                <ul className="tabsList">
																	{productSpecsData.ownersManualLink !== ""
																		?<li><a href={productSpecsData.ownersManualLink} target="_blank">Owner&apos;s Manual</a></li>
																		:null
																	}
																	{productSpecsData.installationInstructionLink !== ""
																		?<li><a href={productSpecsData.installationInstructionLink} target="_blank">Installation Instructions</a></li>
																		:null
																	}
																	{productSpecsData.quickSpecsLink !== ""
																		?<li><a href={productSpecsData.quickSpecsLink} target="_blank">Quick Specs</a></li>
																		:null
																	}
																	{productSpecsData.energyGuideLink !== ""
																		?<li><a href={productSpecsData.energyGuideLink} target="_blank">Energy Guide</a></li>
																		:null
																	}
								                                </ul>
								                                {/* END: EXISTING CONTENT NOT MODIFIED */}
								                                {/* CNET CHANGE HERE: addition */}
								                                <div className="emailSpecLinkDiv">
								                                	<a className="withIcon withEmailSpecIcon bold uppercase" onClick={this.handleClickEmailSpec.bind(this)} href="">Email Spec</a>
								                                </div>
							                              	</div>
							                              	{/* CNET CHANGE HERE: remove reviews related content */}
							                              	{/*googleoff: all*/} {/* DO NOT REMOVE THIS */}
							                              	<div className="sectionPush">
							                                	<div id="printFriendly2"><a href="" onClick={this.printPDF.bind(this)}><img src={geUrlImageRootImages+"/common/icon_print.gif"} width={16} height={17} alt="Printer-friendly page" title="Printer-friendly page" />Print Product Specs</a></div>
							                              	</div>
							                              	{/*googleon: all*/} {/* DO NOT REMOVE THIS */}
					                            		</td>
					                          		</tr>
					                        	</tbody>
					                      	</table>
										</div>
		                                <div style={{display: 'none'}} className="tab_content" id="tab2">
											<table cellPadding={5} cellSpacing={0} id="tabletab2" style={{width: '100%'}} summary="Detailed product information">
					                        	<tbody>
													<tr>
						                            	<td className="anotherTD">
							                              	<div style={{width: 600}} className="hideForPrint">
							                                	<div style={{float: 'right'}}>
							                                  		<span style={{color: '#459FD3'}}>+ <a href="" onClick={this.collapseExpandAll.bind(this, true)}>expand all</a></span> &nbsp; | <span style={{color: '#459FD3'}}>- <a href=""  onClick={this.collapseExpandAll.bind(this, false)}>collapse all</a></span>
							                                	</div>
							                                	<div className="clear"></div>
							                              	</div>
															{productSpecsData.sortedFeaturesList && productSpecsData.sortedFeaturesList.map((item, index) => {
																if(item.key === 'FILTER') return null;
																return  <div key={index}>
		                                            				<h3 className="acc_trigger active" onClick={this.toggleCollapseExpand.bind(this)}>
		                                                                <a href="" onClick={(e)=>{e.preventDefault()}}>{item.key}</a>
		                                                            </h3>
		                                            				<div className="acc_container">
		                                            					<div className="block">
		                                                                    <table cellPadding={0} cellSpacing={0} className="graybarTable" style={{padding: '0 0 10px 0', tableLayout: 'auto'}} summary="Product features">
		                                                                        {item.key==='WEIGHTS & DIMENSIONS'
		                                                                            ?<tbody>
		                                                                                {item.list.map((itm, ind) => {
		                                                                                    return <tr key={ind}>
		                                                                                        <td className="colA">{itm.displayName}</td>
		                                                                                        {itm.displayName==="Total Capacity (cubic feet)"
																									?<td className="colB">
		                                                                                                {productSpecsData.overallCapacity}
		                                                                                            </td>
		                                                                                        	:(itm.displayName==="Overall Height"
																										?<td className="colB">
				                                                                                            {productSpecsData.productHeight && productSpecsData.productHeight.length > 0 ? productSpecsData.productHeight[0] : ''}
				                                                                                        </td>
																										:(itm.displayName==="Overall Width"
																											?<td className="colB">
					                                                                                            {productSpecsData.productWidth && productSpecsData.productWidth.length > 0 ? productSpecsData.productWidth[0] : ''}
					                                                                                        </td>
																											:(itm.displayName==="Cutout Dimensions (w x h x d) (in.) "
																												?<td className="colB">
						                                                                                            {itm.Value}
						                                                                                        </td>
																												:(itm.displayName==="Overall Depth"
																													?<td className="colB">
							                                                                                            {productSpecsData.productDepth && productSpecsData.productDepth.length > 0 ? productSpecsData.productDepth[0] : ''}
							                                                                                        </td>
																													:<td className="colB">
							                                                                                            {itm.values.map((it, id) => {
							                                                                                                return <span key={id}>{it.value}<br/></span>
							                                                                                            })}
																													</td>
																												)
																											)
																										)
																									)
		                                                                                        }
		                                                                                    </tr>
		                                                                                })}
		                                                                            </tbody>
		                                                                            :<tbody>
		                                                                                {item.list.map((itm, ind) => {
		                                                                                    return <tr key={ind}>
		                                                                                        <td className="colA">{itm.displayName}</td>
		                                                                                        {itm.displayName==="Total Capacity (cubic feet)"
																									?<td className="colB">
		                                                                                                {productSpecsData.overallCapacity}
		                                                                                            </td>
			                                                                                        :(itm.displayName==="Overall Height"
																										?<td className="colB">
				                                                                                            {productSpecsData.productHeight && productSpecsData.productHeight.length > 0 ? productSpecsData.productHeight[0] : ''}
				                                                                                        </td>
																										:(itm.displayName==="Overall Width"
																											?<td className="colB">
					                                                                                            {productSpecsData.productWidth && productSpecsData.productWidth.length > 0 ? productSpecsData.productWidth[0] : ''}
					                                                                                        </td>
																											:(itm.displayName==="Overall Depth"
																												?<td className="colB">
			                                                                                            			{productSpecsData.productDepth && productSpecsData.productDepth.length > 0 ? productSpecsData.productDepth[0] : ''}
			                                                                                        			</td>
																												:(itm.displayName!=null
																													?<td className="colB">
																														{itm.values.map((it,id)=>{
																															let values = (it.value+'');
																															if(values.includes("href")) {
																															values = values.replace(/href=([^"'\s]+)/g,'href="$1"');
																															const parse = new DOMParser().parseFromString(values,'text/html');
																															const link = parse.querySelector('a');
																															const text = link.href.length>0 ? link.previousSibling?link.previousSibling.textContent.trim():'':'';
																															const href = link.href.length>0 ? link.href:'';
																															const urlText = link.href.length>0 ? link.textContent.length>0 ? link.textContent.trim():'':'';
																															const AfterHrefText = link.href.length>0 ? link.nextSibling ? link.nextSibling.textContent.trim():'':'';
																															return <span key={id}><span>{text+" " }</span>
																															<a href={href} target='_blank' style={{textDecoration:"underline"}}>{urlText}</a>
																															<span>{" "+AfterHrefText}</span><br/>
																															</span> 
																															} 
																															else{
																																return <span key={id}>{it.value}<br/></span> 
																															} 
																														})}  
																													</td>
																													:<td className="colB">
																														{itm.values.map((it, id) => {
																															return <span key={id}>{it.value}<br/></span>
																															}
																															)}
																														</td>
																										  				)
																													)
																						  		  				)
																											)
																										}
																								</tr>
																							})}
		                                                                            </tbody>
		                                                                        }
		                                                                    </table>
		                                            					</div>
		                                            				</div>
		                                            			</div>
															})}
						                            	</td>
						                            	<td className="hideForPrint">
															{/* Start sectionPush */}
															<div className="sectionPush">
																<div className="iconContainer">
																	<img src={geUrlImageRootImages+"/common/icon_anchor.gif"} width={15} height={15} alt="Quick Links" title="Quick Links" />
																</div>
																<h3>Quick Links</h3>
																<ul className="tabsList">
																	{productSpecsData.quickSpecsLink !== ""
																		?<li><a href={productSpecsData.quickSpecsLink} target="_blank">Quick Specs</a></li>
																		:null
																	}
																	{productSpecsData.energyGuideLink !== ""
																		?<li><a href={productSpecsData.energyGuideLink} target="_blank">Energy Guide</a></li>
																		:null
																	}
																</ul>
															</div>
															{/* End sectionPush */}
															{/*googleoff: all*/} {/* DO NOT REMOVE THIS */}
															{/* Start printer-friendly button */}
															<a id="printerFriendly" href="" onClick={this.printPDF.bind(this)}><span>printer-friendly product specs</span></a>
															{/* End printer-friendly button */}
															{/*googleon: all*/} {/* DO NOT REMOVE THIS */}
															<div className="clear"></div>
							                            </td>
						                          	</tr>
						                        </tbody>
											</table>
										</div>
		                                <div style={{display: 'none'}} className="tab_content" id="tab3">
	    									<table cellPadding={5} cellSpacing={0} id="tabletab3" style={{width: '100%'}} summary="Manuals / downloads">
	    		                                <tbody>
	    											<tr>
	    	                                            <td className="anotherTD">
														{productSpecsData.documents.map((item, index) => (
															<div 
															key={index} 
															style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}
															>
															<div style={{ width: 30 }}>
																<img 
																src={geUrlImageRootImages + "/common/icon_large_pdf.gif"} 
																width={20} 
																height={20} 
																alt="PDF" 
																title="PDF" 
																/>
															</div>
															<div style={{ marginLeft: "8px" }}>
																<span style={{ fontSize: 14 }}>
																<a href={item.documentPath} target="_blank" rel="noreferrer">
																	{item.type}
																</a>
																</span>
																
															</div>
															</div>
														))}
	    	                                    		</td>
	    					                            <td>
	    					                            	<div className="rightColumntabs">
	    					                                	<div className="sectionPush">
	    						                                	{/* BEGIN EcoRebates Widget */}
	    						                                  	<div id="rebateFormatTab" style={{}}>
	    						                                    	<div className="iconContainer">
	    						                                      		$
	    						                                    	</div>
	    						                                    	<h3>Rebates</h3>
	    						                                    	<br />
	    						                                    	<div id="ecorebatesTab" className="ecorebates" style={{}}>
	    						                                    	</div>
	    						                                  	</div>
	    						                                </div>
	    						                                <br />
	    						                                {/* END EcoRebates Widget */}
	    						                                <div className="clear"></div>
	    					                              	</div>
	    					                            </td>
	    				                          	</tr>
	    				                        </tbody>
	    									</table>
	    								</div>
		                                <div style={{display: 'none'}} className="tab_content" id="tab6">
		                                    {productSpecsData.pairing_Models && productSpecsData.pairing_Models.length > 0?<h3>Related Products</h3>:null}
		                                    <div style={{margin: '20px 0 0 0'}}>
		                                        {productSpecsData.pairing_Models && productSpecsData.pairing_Models.map((item, index) => {
		                                            if(item.sku&&item.sku!==productSpecsData.sku){
		                                                var msrpData = _.find(product.productSpecsMSRP, ["sku", item.sku]);
		                                            }
		                                            return (item.sku?<div key={item.sku} className="smallColumn">
		                                                <img src={item.imagePath} width={96} height={100} alt={item.description} title={item.description} className="floatLeft" style={{margin: '0 7px 0 0'}} />
		                                                <Link to={this.state.basePath+"/product-specs/"+this.props.params.typeOfSearch+"/"+item.sku}>{item.description}</Link>
		                                                <br /><br />
		                                                <span>{item.sku}</span><br />
		                                                <span id="priceDollarsign" style={{fontWeight: 'bold',}}>$</span><span id="price" style={{fontWeight: 'bold'}}>{msrpData?+msrpData.msrp:null}</span> <a href="" onClick={this.handleDialog.bind(this, 'EstRetailPriceTooltipOverlayDialog', true)}>MSRP</a>
		                                            </div>:null)
		                                        })}
		                                        </div>
		                                        <div className="clear"></div>
												{accessoriesItem?<h3>Accessories &amp; Replacement Parts</h3>:null}
											<div style={{margin: '20px 0 0 0'}}>												
												{ accessoriesItem && accessoriesItem.map((item, index)=>{
													if(item !== null){
														return <div key={item.sku} className="smallColumn">
																	<img src={item.images.length > 0 ? item.images.filter((itm)=>{return itm.defaultImage == true}).length > 0 ? item.images.filter((itm)=>{return itm.defaultImage == true})[0].imagePath : "" :""} width={96} height={100} alt={item.description} title={item.description} className="floatLeft" style={{margin: '0 7px 0 0'}} />
																	<Link to={this.state.basePath+"/product-specs/"+this.props.params.typeOfSearch+"/"+item.sku}>{item.description}</Link>
																	<br /> 
																	<span>{item.sku}</span>
																</div>
													}
												})}
				                                <div className="clear"></div>
		                                    </div>
		                                </div>
		                            </div>
				                </div>
				                {/* End tabs section */}
				                <div className="clear"></div>
							</div>
						:null}
		            </div>
					:null
				}
				{product && product.productSpecs && product.productSpecs.responseObject && product.productSpecs.responseObject === 'NA'
					?<div>
						<br />
						<br />
						<h1 id="SKUonspec">{self.props.params.sku}</h1>
						<h1 id="model" className="red">No Data Found.</h1>
					</div>
					:null
				}
				{(this.state.showAvailabilityDetailsOverlayDialog)?<AvailabilityDetailsOverlayDialog isPrelogin={this.state.isPrelogin} availability={this.state.availability} handleDialog={this.handleDialog.bind(this)} showDialog={true} sku={productSpecsData.sku} {...this.props} />:null}
				{(this.state.showEstRetailPriceTooltipOverlayDialog)?<EstRetailPriceTooltipOverlayDialog handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
				{this.state.showEmailSpecOverlayDialog?<EmailSpecOverlayDialog specURL={this.state.specURL} dispatch={this.props.dispatch} handleDialog={this.handleDialog.bind(this)} showDialog={true}/>:null}
				{(this.props.state && this.props.state.brochure.emailSendSuccessDialog === true)?<EmailSpecOverlayDialogSuccess dispatch={this.props.dispatch} showDialog={true}/>:null}
			</div>
        );
    }
}
const mapStateToProps = (state) => {
	return { state };
};

const mapDispatchToProps = (dispatch) => ({
	getProductSpecs: (payload, callback) => dispatch(getProductSpecs(payload, callback)),
	saveProductSpecs: (payload) => dispatch(saveProductSpecs(payload)),
	printSpecsPDF: (payload, callback) => dispatch(printSpecsPDF(payload, callback)),
});

ProductSpecPage = connect(mapStateToProps, mapDispatchToProps)(ProductSpecPage);
export default ProductSpecPage;



// WEBPACK FOOTER //
// ./src/App/components/common/ProductSpecPage/index.js